export default class Filename
{
    _maxLength = 256
    _separator = ' - '

    constructor(value, extension)
    {
        this._value = value
        this._extension = extension
    }

    prepend(value)
    {
        const formattedValue = this._format(value)
        if(this._remainingLength() <= 0 || formattedValue.length === 0)
        {
            return new Filename(this._value, this._extension)
        }

        return new Filename(formattedValue + this._separator + this._value, this._extension)
    }

    append(value)
    {
        const formattedValue = this._format(value)
        if(this._remainingLength() <= 0 || formattedValue.length === 0)
        {
            return new Filename(this._value, this._extension)
        }

        return new Filename(this._value + this._separator + formattedValue, this._extension)
    }

    prependSubstring(value, length)
    {
        return this.prepend(this._format(value).substring(0, length))
    }

    value()
    {
        return this._value + '.' + this._extension
    }

    _format(value)
    {
        return this._truncate(
            this._sanitize(value)
        )
    }

    _truncate(value)
    {
        return value.substring(0, this._remainingLength() - this._separator.length)
    }

    _remainingLength()
    {
        return Math.max(0, this._maxLength - this._value.length - this._extension.length - 1)
    }

    _sanitize(value)
    {
        return value
            .replace(/[?:/*<>|"]/gi, ' ')
            .replace(/\s{2,}/g, ' ')
            .trim()
    }
}
